import { adminApi } from '@/model/admin/api.generated';

export function registerAdminTags(): void {
  adminApi.enhanceEndpoints({
    endpoints: {
      postApiAdminWorkspacesByIdMembers: { invalidatesTags: ['workspaces', 'admin'] },
      deleteApiAdminWorkspacesByIdMembersAndUserId: { invalidatesTags: ['workspaces', 'admin'] },
      postApiAdminProjectsByProjectIdMembers: { invalidatesTags: ['projects', 'admin'] },
      deleteApiAdminProjectsByProjectIdMembersAndUserId: { invalidatesTags: ['projects', 'admin'] },
      patchApiAdminWorkspacesByIdPlan: { invalidatesTags: ['admin', 'workspaces'] },
    },
  });
}
